/**
 * Expert Testimonials - Avatar Navigation & Slider Sync
 */

class ExpertTestimonials {
  constructor(container) {
    this.container = container;
    this.avatars = container.querySelectorAll('[data-expert-avatar]');
    this.slider = container.querySelector('[data-expert-slider]');
    this.swiperInstance = null;

    this.init();
  }

  init() {
    if (!this.slider) return;

    // Wait for Swiper to be initialized
    this.waitForSwiper();

    // Add click handlers to avatars
    this.avatars.forEach((avatar) => {
      avatar.addEventListener('click', (e) => {
        const index = parseInt(avatar.dataset.index);
        this.goToSlide(index);
      });
    });
  }

  waitForSwiper() {
    // Offscreen sliders initialize on approach; do not poll while they are idle.
    const checkSwiper = () => {
      if (this.slider.swiper && this.swiperInstance !== this.slider.swiper) {
        this.swiperInstance = this.slider.swiper;
        this.setupSwiperListeners();
      }
    };
    this.container.addEventListener('theme:swiper-ready', checkSwiper);
    checkSwiper();
  }

  setupSwiperListeners() {
    if (!this.swiperInstance) return;

    // Listen to slide changes
    this.swiperInstance.on('slideChange', () => {
      const activeIndex = this.swiperInstance.activeIndex;
      this.updateActiveAvatar(activeIndex);
    });
  }

  goToSlide(index) {
    if (this.swiperInstance) {
      this.swiperInstance.slideTo(index);
    }
    this.updateActiveAvatar(index);
  }

  updateActiveAvatar(index) {
    // Remove active class from all avatars
    this.avatars.forEach((avatar) => {
      avatar.classList.remove('expert-testimonials__avatar--active');
    });

    // Add active class to current avatar
    const activeAvatar = this.container.querySelector(`[data-expert-avatar][data-index="${index}"]`);
    if (activeAvatar) {
      activeAvatar.classList.add('expert-testimonials__avatar--active');

      // Scroll avatar into view on mobile
      this.scrollAvatarIntoView(activeAvatar);
    }
  }

  scrollAvatarIntoView(avatar) {
    const scrollContainer = avatar.closest('.expert-testimonials__avatars-scroll');
    if (!scrollContainer) return;

    const containerRect = scrollContainer.getBoundingClientRect();
    const avatarRect = avatar.getBoundingClientRect();

    // Calculate scroll position to center the avatar
    const scrollLeft = scrollContainer.scrollLeft;
    const avatarCenter = avatarRect.left - containerRect.left + avatarRect.width / 2;
    const containerCenter = containerRect.width / 2;
    const targetScroll = scrollLeft + avatarCenter - containerCenter;

    scrollContainer.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }
}

// Initialize all expert testimonial sections on the page
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.expert-testimonials');
  sections.forEach((section) => {
    new ExpertTestimonials(section);
  });
});
